import React from 'react';
import { cn } from '@/lib/cn';
import { IconVerified, IconCrossCircle } from '@repo/svgs';

export interface ChipProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Label text shown inside the chip */
  label: string;
  /** Leading icon (16px). Pass `true` to show the verified icon. */
  leadingIcon?: React.ReactNode | boolean;
  /** Called when the dismiss (cross) icon is clicked */
  onRemove?: () => void;
}

export function Chip({ label, leadingIcon = false, onRemove, className, ...props }: ChipProps) {
  const resolvedLeadingIcon =
    leadingIcon === true ? <IconVerified /> : leadingIcon ? leadingIcon : null;

  return (
    <div
      onClick={onRemove}
      className={cn(
        'flex items-center justify-center gap-2',
        'rounded-full',
        'text-primary bg-active hover:bg-active-hover',
        'px-3 py-2',
        'cursor-pointer',
        className,
      )}
      {...props}
    >
      {resolvedLeadingIcon ? <span className="w-4 h-4 shrink-0">{resolvedLeadingIcon}</span> : null}

      <span className={cn('text-body-2 text-primary whitespace-nowrap')}>{label}</span>

      <button
        type="button"
        aria-label="Remove"
        className={cn(
          'w-4 h-4 shrink-0 inline-flex items-center justify-center rounded-full',
          'icon-tertiary',
          'hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40',
        )}
      >
        <IconCrossCircle />
      </button>
    </div>
  );
}

export default Chip;
